import { Avatar, Flex, Image, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { getSrc } from '../../../../../utils/common/getSrc';

type Props = {
    readonly image: string;
    readonly title: string;
};

export const ChatAvatar = ({ image, title }: Props) => {
    return (
        <ChatTitle align={'center'}>
            <Space>
                {image && (
                    <Avatar
                        src={
                            <Image
                                preview={false}
                                src={getSrc(image)}
                                alt='avatar'
                            />
                        }
                    />
                )}
                {title}
            </Space>
        </ChatTitle>
    );
};

const ChatTitle = styled(Flex)`
    cursor: pointer;
`;
